export default __webpack_public_path__ + "static/media/pd-table.76469fa6.webp";